import { alertVariants } from "@visiblethread/react-components";

import localhost from "../../../apis/localhost";
import { showGlobalAlert } from "../../app/appSlice";
import { CONNECTIVITY_ERROR } from "./constants";

export const unpinSharepointSite = (siteId) => async (dispatch) => {
  try {
    const response = await localhost.delete(`/sharepoint/sites/${siteId}/pin`);

    if (response.status < 200 || response.status >= 300) {
      const error = new Error();
      error.code = response.status;
      throw error;
    }

    return response;
  } catch (error) {
    dispatch(
      showGlobalAlert({
        text: CONNECTIVITY_ERROR,
        variant: alertVariants.danger,
      })
    );
  }
  return null;
};
